export const SCROLL_SCOPE = {
  WORK_ORDERS: {
    LIST: "/app/work/work-orders/list",
    BOARD: "/app/work/work-orders/board",
    TABLE: "/app/work/work-orders/table",
    CALENDAR: "/app/work/work-orders/calendar",
    MAP: "/app/work/work-orders/map",
  },
  MY_WO_LIST: "/app/my-work-orders",
  SUPPORT_TICKETS: {
    LIST: "/app/work/tickets/list",
    BOARD: "/app/work/tickets/board",
    TABLE: "/app/work/tickets/table",
    MAP: "/app/work/tickets/map",
  },
  ASSETS: {
    LIST: "/app/asset-hub/my-assets/list",
    TABLE: "/app/asset-hub/my-assets/table",
    BOARD: "/app/asset-hub/my-assets/board",
    CALENDAR: "/app/asset-hub/my-assets/calendar",
  },
  PRODUCTS: {
    LIST: "/app/asset-hub/my-products/list",
    GRID: "/app/asset-hub/my-products/grid",
  },
  COMPANIES: {
    LIST: "/app/asset-hub/companies/list",
    TABLE: "/app/asset-hub/companies/table",
    BOARD: "/app/asset-hub/companies/board",
  },
  PORTALS: {
    LIST: "/app/customer-portal/my-portals",
  },
  PROCEDURE_TEMPLATES: {
    LIST: "/app/work/procedures/templates",
  },
  FILLED_PROCEDURES: {
    LIST: "/app/work/procedures/filled",
  },
  MACHINE_LIST_PAGE: "/app/assets/machines",
  PORDUCTION_LINE_LIST_PAGE: "/app/assets/production-lines",
  FACILITY_LIST_PAGE: "/app/facilities",
  INVENTORY_LIST_PAGE: "/app/inventory",
  DOCUMENTS: {
    SUBMISSIONS: "/app/documents",
    TEMPLATES: "/app/documents/templates",
  },
  FINANCE_QUOTES: {
    TABLE: "/app/work/quotes/table",
    BOARD: "/app/work/quotes/board",
  },
  FINANCE_INVOICES: {
    TABLE: "/app/work/invoices/table",
    BOARD: "/app/work/invoices/board",
  },
};
